import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface CratNewModalPayload {
  data?: null;
  type: ModalType.CratNew;
  isOpen?: boolean;
}

export const CratNewModal = React.forwardRef<
  HTMLElement,
  Pick<CratNewModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Layer-1 Blockchain (DPoS)"
      subtitle="The Engine of Everything"
      icon={<Icons.CratLogoDark />}
      link={{
        title: 'Explore CratD2C SmartChain',
        link: {
          href: ECOSYSTEM_LINKS.explorer,
          text: ECOSYSTEM_LINKS.explorer,
        },
      }}
    >
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        This is the main blockchain that powers the entire CratD2C ecosystem.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        It uses Delegated Proof-of-Stake (DPoS), which means the community chooses trusted validators to confirm
        transactions quickly and securely.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        For a normal user, it simply means fast, low-cost, and reliable transactions, even when millions of people are
        using the network.
      </Typography>
    </ModalSidebar>
  );
});
